import { render, staticRenderFns } from "./SeparaterLine.vue?vue&type=template&id=fff0297a&scoped=true&"
import script from "./SeparaterLine.vue?vue&type=script&lang=js&"
export * from "./SeparaterLine.vue?vue&type=script&lang=js&"
import style0 from "./SeparaterLine.vue?vue&type=style&index=0&id=fff0297a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff0297a",
  null
  
)

export default component.exports